// Preference.js (API module)
import axiosInstance from '@/lib/axios';

export async function setSportPreference(data) {
  try {
    const response = await axiosInstance.patch('/users/preferences', data, {
      headers: {
        'Content-Type': 'application/json', // important for JSON
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      'Failed to update profile: ' + (error.response?.data || error.message)
    );
  }
}

export async function getUserPreference() {
  try {
    const response = await axiosInstance.get('/users/preferences');
    return response.data;
  } catch (error) {
    throw new Error(
      'Failed to load preference: ' + (error.response?.data || error.message)
    );
  }
}

export async function fetchAvailableSports() {
  try {
    const response = await axiosInstance.get('/users/preferences/sports');
    return response.data;
  } catch (error) {
    throw new Error(
      'Failed to load sports: ' + (error.response?.data || error.message)
    );
  }
}
